import React from 'react';
import Toggle from '../ui/Toggle';
import styles from './SaveSegmentBar.module.css';

class SaveSegmentBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = { enabled: !!props.isEditing || !!props.alwaysShowSave, name: props.initialName || '' };
  }

  render() {
    const { enabled, name } = this.state;
    const { onSave, isEditing, alwaysShowSave } = this.props;
    const showFields = enabled || alwaysShowSave;

    return (
      <div className={styles.bar}>
        {!alwaysShowSave && (
          <>
            <Toggle
              checked={enabled}
              onChange={v => this.setState({ enabled: v })}
              size="sm"
            />
            <span className={styles.label}>{isEditing ? 'Update this segment' : 'Save as reusable segment'}</span>
          </>
        )}
        {showFields && (
          <>
            <input
              className={styles.input}
              placeholder="Segment name…"
              value={name}
              onChange={e => this.setState({ name: e.target.value })}
            />
            <button
              className={styles.saveBtn}
              disabled={!name.trim()}
              onClick={() => onSave && onSave(name.trim())}
            >
              {isEditing ? 'Update' : 'Save'}
            </button>
          </>
        )}
      </div>
    );
  }
}

export default SaveSegmentBar;
